import { EuActivityType, EuObjective, EuObjectives } from '@upright/common/model/input/eu-taxonomy/types';
import { formatRatioAsPercentage } from '../../../../../generic/utilities/format';

export function formatAlignmentValue(value: number | undefined) {
  return formatRatioAsPercentage(value, 1, true, true);
}

export function getEuObjectiveShortName(objective: EuObjective) {
  switch (objective) {
    case 'union':
      return 'All objectives';
    case 'climate':
      return 'Climate';
    case 'mitigation':
      return 'CCM';
    case 'adaptation':
      return 'CCA';
    case 'water':
      return 'WTR';
    case 'circular':
      return 'CIR';
    case 'pollution':
      return 'POL';
    case 'biodiversity':
      return 'BIO';
    case 'mitigationFossilGas':
    case 'mitigationNuclear':
    case 'mitigationOther':
    default:
      return 'Missing data';
  }
}

export function getEuActivityTypeExplanation(type: EuActivityType): string {
  switch (type) {
    case 'transitional':
      return "Economic activities qualifying as a substantial contribution due to their current impacts being lower than the industry average, where no viable better alternatives exist, and the activities don't hamper sustainable development. Example: power production using nuclear power.";
    case 'enabling':
      return 'Economic activities that, by provision of their products or services, enable a substantial contribution to be made in other activities. Example: an economic activity that manufactures a component that improves the environmental performance of another activity.';
    case 'direct':
      return 'Economic activities making a substantial contribution. Example: solar panels substantially contribute to climate change mitigation.';
    case 'any':
      return 'The total figure represents the union of activity types. If all activity type figures are derived from different items, the total is the sum of the individual figures. In general however, the activity type figures are derived from an overlapping set of items, so the total is less than the sum of its components.';
    default:
      return '';
  }
}

export const objectivesInOrder: EuObjectives[] = [
  EuObjectives.union,
  EuObjectives.climate,
  EuObjectives.mitigation,
  EuObjectives.adaptation,
  EuObjectives.water,
  EuObjectives.circular,
  EuObjectives.pollution,
  EuObjectives.biodiversity,
];

// N.B.: This assumes the chapter input is validated to match /^B?[0-9]+\.[0-9]+\.([a-z0-9]?)$/
// Keep consistent with EU Taxonomy sheet
export function cleanChapter(rawChapter: string) {
  return /B?[0-9]+\.[0-9]+/.exec(rawChapter)?.[0] || rawChapter;
}
